function generateHashFromString(string) {
  let hash = 0; let i; let chr;
  if (string.length === 0) return hash;

  for (i = 0; i < string.length; i++) {
    chr = string.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }

  return hash;
}

/**
 * Creates a duplicate-free version of an array.
 * @param {any[]} array - The array to inspect.
 * @return {any[]} - The new duplicate free array.
 */
function getUniqueValues(array) {
  return Array.from(new Set(array));
}

const getUnrenderedElementBounds = (element) => {
  element.style.display = "block";
  element.style.visibility = "hidden";
  const result = element.getBoundingClientRect();
  element.style.removeProperty('display');
  element.style.removeProperty('visibility');

  return result;
};

module.exports = {
  generateHashFromString,
  getUniqueValues,
  getUnrenderedElementBounds,
};
